import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { Form, Button } from 'antd';
import { injectIntl, FormattedMessage } from 'react-intl';
import styled from '@emotion/styled';
import { passwordRegExp } from './passwordRegExp';
import CustomInput from '../common/Input';
import ENUMS from '../../constants/enums';
import InputToggleShowPassword from '../common/InputToggleShowPassword';
// import {getAuthLocation} from '../../utils/getAuthLocation';

const { INFO } = ENUMS.TOAST_TYPES;

const FormItem = styled(Form.Item)`
  margin: 5px;
  & label {
    font-weight: 400 !important;
  }
`;
@injectIntl
@Form.create()
@inject('toastsStore')
@inject('sessionStore')
@observer
class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isChangePassword: false,
      confirmDirty: false,
      oldPasswordToShow: '********',
    };
  }

  changePassword = e => {
    e.preventDefault();
    const {
      toastsStore,
      form,
      intl: { formatMessage },
      sessionStore,
    } = this.props;
    form.validateFieldsAndScroll((error, values) => {
      if (!error) {
        const { newPassword, confirm } = values;
        sessionStore.changePassword(newPassword, confirm).then(() => {
          toastsStore.showToast({
            type: INFO,
            message: formatMessage({ id: 'changePassword.successMessage' }),
          });
          this.setState({
            isChangePassword: !this.state.isChangePassword,
          });
        });
      }
    });
  };

  /** AntD form validation functions
   * @param {Object} rule the input type and it's format
   * @param {String} value the Input's value - that needs that be validated
   * @param {Function} callback the callback function to be called after validation
   */
  validateToNextPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  compareToFirstPassword = (rule, value, callback) => {
    const { form, intl } = this.props;
    if (value && value !== form.getFieldValue('newPassword')) {
      callback(intl.formatMessage({ id: 'changePassword.inconsistent' }));
    } else {
      callback();
    }
  };

  handleConfirmBlur = e => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  startChangePassword = () => {
    this.setState({
      isChangePassword: !this.state.isChangePassword,
      oldPasswordToShow: '********',
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { intl } = this.props;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    return (
      <Fragment>
        <FormItem
          {...formItemLayout}
          label={intl.formatMessage({ id: 'changePassword.oldPassword' })}
        >
          {getFieldDecorator('oldPassword', {
            initialValue: this.state.oldPasswordToShow,
            rules: [
              {
                required: true,
                message: intl.formatMessage({ id: 'changePassword.promptPassword' }),
              },
            ],
          })(
            <CustomInput
              type="password"
              // disabled={!this.state.isChangePassword}
              disabled
              onChange={this.inputChange}
            />,
          )}
          <a style={{ marginLeft: '10px' }} onClick={() => this.startChangePassword()}>
            {!this.state.isChangePassword ? 'edit' : 'cancel'}
          </a>
        </FormItem>
        {this.state.isChangePassword && (
          <div>
            <FormItem
              {...formItemLayout}
              label={intl.formatMessage({ id: 'changePassword.newPassword' })}
            >
              {getFieldDecorator('newPassword', {
                rules: [
                  {
                    required: true,
                    message: intl.formatMessage({ id: 'changePassword.promptNewPassword' }),
                  },
                  {
                    pattern: passwordRegExp.title,
                    message:
                      'Password rules: contains at least 8 characters; not your email address;',
                  },
                  {
                    pattern: passwordRegExp.letterSmall,
                    message: ' at least one lowercase letter (a-z);',
                  },
                  {
                    pattern: passwordRegExp.letterCap,
                    message: ' at least one uppercase letter (A-Z);',
                  },
                  {
                    pattern: passwordRegExp.number,
                    message: ' at least one number (0-9);',
                  },
                  {
                    pattern: passwordRegExp.sym,
                    message: ' at least a symbol;',
                  },
                  {
                    validator: this.validateToNextPassword,
                  },
                ],
              })(<CustomInput type="password" suffix={<InputToggleShowPassword />} />)}
            </FormItem>
            <FormItem
              {...formItemLayout}
              label={intl.formatMessage({ id: 'changePassword.confirmNewPassword' })}
            >
              {getFieldDecorator('confirm', {
                rules: [
                  {
                    required: true,
                    message: intl.formatMessage({
                      id: 'changePassword.promptConfirmNewPassword',
                    }),
                  },
                  {
                    validator: this.compareToFirstPassword,
                  },
                ],
              })(
                <CustomInput
                  type="password"
                  suffix={<InputToggleShowPassword onBlur={this.handleConfirmBlur} />}
                />,
              )}
            </FormItem>
            <Button type="normal" htmlType="submit" onClick={this.changePassword}>
              <FormattedMessage
                id="changePassword.changePassword"
                defaultMessage="Change Password"
              />
            </Button>
          </div>
        )}
      </Fragment>
    );
  }
}

ChangePassword.propTypes = {
  userName: PropTypes.string,
  form: PropTypes.object,
  intl: PropTypes.object,
  sessionStore: PropTypes.object,
  toastsStore: PropTypes.object,
};

export default ChangePassword;
